<template>
  <div class="OCoursel">
    <!-- 弃用 -->
    <Header msg='课程列表'/>
    <div style="height:0.44rem"></div>
    <div class="video-list">
        <div class="video-item flex flex-a-i-center" @click="toDetail">
            <img class="video-img" src="@/assets/mine/course_bg01@3x.png">
            <div class="video-item-right flex flex-j-c-center">
                <p>语文基础（本科）</p>
                <span>课时1</span>
            </div>
        </div>
        <div class="video-item flex flex-a-i-center">
            <img class="video-img" src="@/assets/mine/course_bg01@3x.png">
            <div class="video-item-right flex flex-j-c-center">
                <p>语文基础（本科）</p>
                <span>课时1</span>
            </div>
        </div>
        <div class="video-item flex flex-a-i-center">
            <img class="video-img" src="@/assets/mine/course_bg01@3x.png">
            <div class="video-item-right flex flex-j-c-center">
                <p>语文基础（本科）</p>
                <span>课时1</span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'OnlineCourseList',
  components: {
    Header,
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
    toDetail() {
      this.$router.push({name:'CourseDetail'})
    }
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
  .OCoursel{
    min-height: 100vh;
    .video-list{
        margin-top: 0.1rem;
        background: white;
        .video-item{
            padding: 0.16rem;
            border-bottom: 1px solid #EEEEEE;
            .video-img{
                width: 1rem;
                height: 0.75rem;
            }
            .video-item-right{
                text-align: left;
                margin-left: 0.18rem;
                flex-direction: column;
                font-size: 0.15rem;
                span{
                    font-size: 0.13rem;
                    color: #FABF01;
                    margin-top: 0.1rem;
                }
            }
        }
    }
    
  }
</style> 

